import {faFrown, faSadTear, faSmile} from '@fortawesome/free-solid-svg-icons';

export namespace AlarmsConstants {

  export const ALARM_TYPE = {
    STATIC_AMPLITUDE: 'static-amplitude-alarm',
    STATIC_THRESHOLD: 'static-threshold-alarm',
    COMBINATION: 'combination-alarm',
    THRESHOLD: 'threshold-alarm',
    LIRIS_LOCATION: 'liris-location-alarm',
    OPERATING: 'operating-alarm',
    ALARM_REMINDER_INTERVAL: 'alarm-reminder-interval',
    DATA_USAGE: 'data-usage-alarm',
    CONSOLIDATED_EVENT_DYN: 'consolidated-event-dyn-alarm'
  };
  export const ALARM_WITH_GENERIC_PARAM = [ALARM_TYPE.STATIC_AMPLITUDE, ALARM_TYPE.STATIC_THRESHOLD, ALARM_TYPE.COMBINATION];

  export const ALARM_WITH_LOCATIONS = [ALARM_TYPE.THRESHOLD, ALARM_TYPE.LIRIS_LOCATION, ALARM_TYPE.STATIC_AMPLITUDE, ALARM_TYPE.STATIC_THRESHOLD, ALARM_TYPE.OPERATING, ALARM_TYPE.CONSOLIDATED_EVENT_DYN];

  export const REFERENCE_TYPE = {
    ALARM_TYPE: 'alarm-type',
    ALARM_REMINDER_INTERVAL: 'alarm-reminder-interval'
  };

  export const ALARM_TYPE_OPERATING_DEFAULT = {
    ACTIVE: true,
    DEVICE_TYPE: 1,
    STARTING_MODE: 'first-measure',
    REMINDER_INTERVAL: '6hours',
    PERIOD: 6
  };
  export const ALARM_TYPE_DATA_USAGE = {
    ACTIVE: true,
  };

  export const STATUS = {
    REJECTED: {
      VALUE: '0',
      COLOR: 'red',
      ICON: faSadTear
    },
    TO_VALID: {
      VALUE: '1',
      COLOR: 'orange',
      ICON: faFrown
    },
    VALID: {
      VALUE: '2',
      COLOR: 'green',
      ICON: faSmile
    }
  };


}
